import { Link } from "react-router-dom";
import { useState } from "react";
import { forget } from "@/server/api-services";
import { Button, Text, Input } from "rizzui";
import { SubmitHandler } from "react-hook-form";
import { Form } from "@/ui/form";
import routes from "@/routers/routes";
import ResetPasswordForm from "./reset-password-form";

const initialValues = {
  email: "",
};


export default function ForgetPasswordForm() {
  const [reset, setReset] = useState({});
  const [showReset, setShowReset] = useState(false);

  const onSubmit: SubmitHandler<any> = async (data) => {
    try {
      const response = await forget(data);
      if (response.statusCode !== 200) {
        throw new Error(response.message);
      }
      setReset(initialValues);
      setShowReset(true);
    } catch (error: any) {
      // Optionally show error to user
      alert(error.message || "Failed to send reset email.");
    }
  };

  if (showReset) {
    return <ResetPasswordForm />;
  }

  return (
    <>
      <Form<any>
        validationSchema={undefined}
        resetValues={reset}
        onSubmit={onSubmit}
        useFormProps={{
          mode: "onChange",
          defaultValues: initialValues,
        }}
        className="pt-1.5"
      >
        {({ register, formState: { errors } }) => (
          <div className="space-y-6">
            <Input
              type="email"
              size="lg"
              label="Email"
              placeholder="Enter your email"
              className="[&>label>span]:font-medium"
              inputClassName="text-sm"
              {...register("email")}
              error={errors.email?.message as string}
            />
            <Button className="mt-2 w-full" type="submit" size="lg">
              Send Reset Link
            </Button>
          </div>
        )}
      </Form>
      <Text className="mt-6 text-center text-[15px] leading-loose text-gray-500 lg:mt-8 lg:text-start xl:text-base">
        Don’t want to reset your password?{" "}
        <Link
          to={routes.auth.signIn1}
          className="font-bold text-gray-700 transition-colors hover:text-blue"
        >
          Sign In
        </Link>
      </Text>
    </>
  );
}
